(() => {
  const root=document.querySelector('#studio-help');
  const launcher=root.querySelector('.help-launcher');
  const panel=root.querySelector('.help-panel');
  const input=root.querySelector('#help-input');
  const form=root.querySelector('.help-form');
  const messages=root.querySelector('.help-messages');
  const close=root.querySelector('.help-close');
  function toggle(open){
    panel.hidden=!open;
    launcher.setAttribute('aria-expanded',String(open));
    root.classList.toggle('is-open',open);
    if(open)input.focus({preventScroll:true});else launcher.focus({preventScroll:true});
  }
  launcher.addEventListener('click',()=>toggle(panel.hidden));
  close.addEventListener('click',()=>toggle(false));
  root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){e.stopPropagation();toggle(false)}});
  function message(text,kind,links=[]){
    const block=document.createElement('div');block.className=`help-${kind}`;
    const p=document.createElement('p');p.textContent=text;block.append(p);
    if(links.length){
      const actions=document.createElement('div');actions.className='help-answer-links';
      links.forEach(link=>{const a=document.createElement('a');a.textContent=link.label+' ↗';a.href=link.href.startsWith('#')&&!document.querySelector(link.href)?'/'+link.href:link.href;
        if(link.href.startsWith('https:')){a.target='_blank';a.rel='noopener'}
        if(link.href.startsWith('#'))a.addEventListener('click',()=>toggle(false));
        actions.append(a);
      });block.append(actions);
    }
    messages.append(block);messages.scrollTop=messages.scrollHeight;
    // Keep this browser-only FAQ session bounded; no personal data is persisted.
    while(messages.children.length>41)messages.firstElementChild.remove();
  }
  function submit(question){
    const text=question.trim().slice(0,700);if(!text)return;
    message(text,'question');input.value='';
    const reply=window.StudioKnowledge.answer(text);message(reply.text,'answer',reply.links);
    root.querySelector('.help-suggestions').hidden=true;
  }
  form.addEventListener('submit',e=>{e.preventDefault();submit(input.value)});
  root.querySelectorAll('[data-question]').forEach(button=>button.addEventListener('click',()=>submit(button.dataset.question)));
})();
